import React from 'react';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Fade from '@mui/material/Fade';

/**
 * @typedef {object} LoadingOverlayProps
 * @property {boolean} open - Whether overlay is visible
 * @property {string} [message='Loading...'] - Loading message to display
 */

/**
 * Full-screen loading overlay with message.
 * Used during authentication operations to provide feedback (NFR-3.2.2).
 *
 * @param {LoadingOverlayProps} props - Component props
 * @returns {React.ReactElement}
 */
const LoadingOverlay = ({ open, message = 'Loading...' }) => {
    return (
        <Backdrop
            open={open}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                backdropFilter: 'blur(4px)',
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 3,
                    }}
                >
                    <CircularProgress color="primary" size={56} thickness={4} />
                    <Typography
                        variant="h6"
                        color="common.white"
                        sx={{ fontWeight: 500 }}
                    >
                        {message}
                    </Typography>
                </Box>
            </Fade>
        </Backdrop>
    );
};

LoadingOverlay.propTypes = {
    open: PropTypes.bool.isRequired,
    message: PropTypes.string,
};

export default LoadingOverlay;
